import aboutInfra from "../../src/assets/images/webp/about-1-infra.webp";
import aboutInfra2 from "../../src/assets/images/webp/about-2-infra.webp";
import aboutInfra3 from "../../src/assets/images/webp/about-3-infra.webp";
import infraServices from "../../src/assets/images/webp/our-services-infra-1.webp";
import infraServices2 from "../../src/assets/images/webp/our-services-infra-2.webp";
import infraServices3 from "../../src/assets/images/webp/our-services-infra-3.webp";
import infraGallery from "../../src/assets/images/webp/story-infra-1.webp";
import infraGallery2 from "../../src/assets/images/webp/story-infra-2.webp";
import infraGallery3 from "../../src/assets/images/webp/story-infra-3.webp";
// second page images
import aboutCorporation from "../../src/assets/images/webp/about-1-corport.webp";
import aboutCorporation2 from "../../src/assets/images/webp/about-2-corport.webp";
import aboutCorporation3 from "../../src/assets/images/webp/about-3-corport.webp";
import corporationServices from "../../src/assets/images/webp/our-services-corpotate-1.webp";
import corporationServices2 from "../../src/assets/images/webp/our-services-corpotate-2.webp";
import corporationServices3 from "../../src/assets/images/webp/our-services-corpotate-3.webp";
import corporationGallery from "../../src/assets/images/webp/story-corpotate-1.webp";
import corporationGallery2 from "../../src/assets/images/webp/story-corpotate-2.webp";
import corporationGallery3 from "../../src/assets/images/webp/story-corpotate-3.webp";
// third page images
import aboutConsultancy from "../../src/assets/images/webp/about-1-consult.webp";
import aboutConsultancy2 from "../../src/assets/images/webp/about-2-consult.webp";
import aboutConsultancy3 from "../../src/assets/images/webp/about-3-consult.webp";
import consultancyServices from "../../src/assets/images/webp/our-services-consult-1.webp";
import consultancyServices2 from "../../src/assets/images/webp/our-services-consult-2.webp";
import consultancyServices3 from "../../src/assets/images/webp/our-services-consult-3.webp";
import consultancyGallery from "../../src/assets/images/webp/story-consult-1.webp";
import consultancyGallery2 from "../../src/assets/images/webp/story-consult-2.webp";
import consultancyGallery3 from "../../src/assets/images/webp/story-consult-3.webp";
// fourth page images
import aboutInvention from "../../src/assets/images/webp/about-1-inovate.webp";
import aboutInvention2 from "../../src/assets/images/webp/about-2-inovate.webp";
import aboutInvention3 from "../../src/assets/images/webp/about-3-inovate.webp";
import inventionServices from "../../src/assets/images/webp/our-services-inovate-1.webp";
import inventionServices2 from "../../src/assets/images/webp/our-services-inovate-2.webp";
import inventionServices3 from "../../src/assets/images/webp/our-services-inovate-3.webp";
import inventionGallery from "../../src/assets/images/webp/story-inovation-1.webp";
import inventionGallery2 from "../../src/assets/images/webp/story-inovation-2.webp";
import inventionGallery3 from "../../src/assets/images/webp/story-inovation-1.webp";
export const aboutDetail = {
  "india-infra": {
    about: {
      title: "Building the Future, One Structure at a Time",
      description: [
        "Make Way India Infra Pvt. Ltd. specializes in infrastructure development, bringing innovation, precision, and sustainability to construction projects. We take pride in designing and building high-quality residential, commercial, and industrial spaces that stand the test of time.",
        "Our team of experienced professionals, architects, and engineers work collaboratively to create modern, efficient, and eco-friendly infrastructure solutions. From smart urban planning to large-scale industrial projects, we ensure that every development is built with durability, functionality, and aesthetics in mind.",
      ],

      second: {
        img: aboutInfra,
        img1: aboutInfra3,
        img2: aboutInfra2,
      },
    },
    services: {
      title: "Smart, Sustainable, & Scalable Solutions",
      description: [
        "At Make Way India Infra Pvt. Ltd., we believe in building infrastructure that is not only technologically advanced but also environmentally responsible and future-ready. Our approach integrates smart design, sustainable materials, and scalable development strategies to create long-lasting solutions that adapt to growing needs.",
      ],
      listBadges: [
        "Residential & Commercial Construction",
        "Road & Highway Development",
        "Industrial Infrastructure",
        "Real Estate & Land Development",
      ],

      second: {
        img: infraServices,
        img2: infraServices2,
        img3: infraServices3,
      },
    },
    gallery: [
      infraGallery,
      infraGallery2,
      infraGallery3,
      infraGallery,
      infraGallery2,
      infraGallery3,
    ],
  },
  "india-corporation": {
    about: {
      title: "A Strong Foundation for Business Growth",
      description: [
        "Make Way India Corporation is dedicated to providing businesses with the right strategies, tools, and resources for sustainable success. Whether you’re a startup or an established enterprise, we help you navigate the ever-changing business landscape.",
        "With our vast experience and industry knowledge, we provide a range of services designed to streamline your operations, maximize your brand potential, and ensure your business remains at the forefront of your industry. From market research and analysis to corporate training and financial management, our team of experts is here to empower your business every step of the way.",
      ],

      second: {
        img: aboutCorporation,
        img1: aboutCorporation3,
        img2: aboutCorporation2,
      },
    },
    services: {
      title: "Empowering Your Business ",
      description: [
        "At Make Way India Corporation, our expertise spans across multiple critical areas of business development. We offer comprehensive solutions designed to address your unique challenges and accelerate growth. With our team of seasoned professionals, we guide you through every phase of your business journey, from strategic planning to execution.",
      ],
      listBadges: [
        "Business Consultation & Growth Strategies",
        "Marketing & Branding Solutions",
        "Corporate Training & Development",
        "Market Research & Analytics",
      ],

      second: {
        img: corporationServices,
        img2: corporationServices2,
        img3: corporationServices3,
      },
    },
    gallery: [
      corporationGallery,
      corporationGallery2,
      corporationGallery3,
      corporationGallery,
      corporationGallery2,
      corporationGallery3,
    ],
  },
  "india-consultancy": {
    about: {
      title: "Expert Guidance for a Brighter Tomorrow",
      description: [
        "Make Way India Consultancy offers professional consulting services across various industries, ensuring businesses and individuals achieve their goals efficiently and effectively. Our expert consultants bring years of experience and in-depth knowledge to help you make informed decisions.",
        "Whether you’re looking to optimize business processes, strategize for growth, or navigate complex challenges, we provide insightful guidance and strategic recommendations that deliver measurable results. With a focus on practical, actionable solutions, we ensure your decisions are based on data-driven insights and industry best practices..",
      ],

      second: {
        img: aboutConsultancy,
        img1: aboutConsultancy3,
        img2: aboutConsultancy2,
      },
    },
    services: {
      title: "Tailored Solutions for Every Challenge",
      description: [
        "At Make Way India Consultancy, we specialize in offering expert consulting services across various industries. Our team of experienced consultants is dedicated to understanding your unique needs and providing tailored strategies that drive growth, efficiency, and long-term success.",
      ],
      listBadges: [
        "Business & Startup Consulting",
        "Education & Career Guidance",
        "Financial & Investment Planning",
        "HR & Recruitment Solutions",
      ],

      second: {
        img: consultancyServices,
        img2: consultancyServices2,
        img3: consultancyServices3,
      },
    },
    gallery: [
      consultancyGallery,
      consultancyGallery2,
      consultancyGallery3,
      consultancyGallery,
      consultancyGallery2,
      consultancyGallery3,
    ],
  },
  "india-invention": {
    about: {
      title: "Innovating for a Better Tomorrow",
      description: [
        "Make Way India Invention Pvt. Ltd. is the innovation hub of our organization, dedicated to research, development, and technological advancements. We aim to create groundbreaking solutions that drive progress in various industries.",
        "We are dedicated to pushing the boundaries of what’s possible by harnessing the power of cutting-edge technology and sustainable practices. By combining creativity, technical expertise, and a deep understanding of industry needs, we aim to revolutionize sectors ranging from green energy to advanced automation and artificial intelligence. ",
      ],

      second: {
        img: aboutInvention,
        img1: aboutInvention3,
        img2: aboutInvention2,
      },
    },
    services: {
      title: "Pioneering Innovation Across Industries",
      description: [
        "At Make Way India Invention Pvt. Ltd., we focus on advancing the technologies that will shape the future. Our innovative solutions span a range of industries, from cutting-edge research and development to sustainable energy and AI-driven applications. ",
      ],
      listBadges: [
        "Product Development & Prototyping",
        "AI & Machine Learning Applications",
        "Green Energy & Sustainable Innovations",
        "Technology & Automation Solutions",
      ],

      second: {
        img: inventionServices,
        img2: inventionServices2,
        img3: inventionServices3,
      },
    },
    gallery: [
      inventionGallery,
      inventionGallery2,
      inventionGallery3,
      inventionGallery,
      inventionGallery2,
      inventionGallery3,
    ],
  },
};
